import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { ReactComponent as CloseIcon } from '../../assets/images/icon/closeOutlined.svg';
import Modal from '../Modal';

const ErrorModal = ({
  isOpen,
  toggle,
}) => (
  <Modal
    aria-labelledby='transition-modal-title'
    aria-describedby='transition-modal-description'
    open={isOpen}
    onClose={toggle}
    className='error-modal'
  >
    <>
      <div className='modal-body'>
        <CloseIcon />
        <h4>We’re sorry. Something went wrong.</h4>
        <p>Connection has failed. Please try again later.</p>
      </div>
      <div className='button-container'>
        <Button className='error-cancel-btn' onClick={toggle}>Close</Button>
        <Button variant='contained' className='error-try-again-btn' onClick={() => (window.location.reload())} sx={{ boxShadow: 0 }}>Try again</Button>
      </div>
    </>
  </Modal>
);

ErrorModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
};

ErrorModal.defaultProps = {
  isOpen: false,
  toggle: (fn) => fn,
};

export default ErrorModal;
